import { PRODUCT_IMAGES } from "../constants/action-types";
import { uploadActions } from "./base-upload-reducers";

export const productImagesUpload = uploadActions(PRODUCT_IMAGES);
